import React, { createContext, useContext, useState } from 'react';
import translationsEn from '../translations/en.json';
import translationsKn from '../translations/kn.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    // Get saved language from localStorage or default to 'en'
    return localStorage.getItem('language') || 'en';
  });

  const translations = {
    en: translationsEn,
    kn: translationsKn
  };

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'kn' : 'en';
    setLanguageState(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  // Explicit setter (used by language picker modal)
  const setLanguage = (lang) => {
    if (lang !== 'en' && lang !== 'kn') return;
    setLanguageState(lang);
    localStorage.setItem('language', lang);
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
